var alertNotifications = {
	alert: {
		limitAbove: "Ultimo prezzo: superiore",
		limitBelow: "Ultimo prezzo: inferiore"
	},
	closeBtn: "Chiudi",
	openHistory: "Open alert history"
};
var it = {
	alertNotifications: alertNotifications
};

export { alertNotifications, it as default };
